type AppRoute = {
  path: string | string[];
  exact?: boolean;
  component: string;
  private?: boolean;
  admin?: boolean;
};

const routes: AppRoute[] = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/", "/login"],
    exact: true,
    component: "Login",
  },
  {
    path: "/dashboard",
    exact: true,
    component: "Dashboard",
    private: true,
  },
  {
    path: "/admin",
    exact: true,
    component: "Admin",
    private: true,
    admin: true,
  },
  {
    path: "/admin/prospects",
    exact: true,
    component: "AdminProspects",
    private: true,
    admin: true,
  },
  {
    path: "/admin/market-intelligence",
    exact: true,
    component: "AdminMarketIntelligence",
    private: true,
    admin: true,
  },
  {
    path: ["/", "/signup"],
    exact: true,
    component: "Signup",
  },
  {
    path: ["/", "/signupcreatebusiness"],
    exact: true,
    component: "SignupCreateBusiness",
  },
  {
    path: ["/", "/createbusiness"],
    exact: true,
    component: "CreateBaseBusiness",
    private: true,
  },
  {
    path: ["/", "/success"],
    exact: true,
    component: "Success",
  },
  {
    path: "/pages/:businessId/products/:productId",
    component: "BusinessWebsite",
  },
  {
    path: "/pages/:businessId/product/:productId",
    component: "BusinessWebsite",
  },
  {
    path: "/pages/:businessId",
    exact: true,
    component: "BusinessWebsite",
  },
  {
    path: "/pages/:businessId/*",
    component: "BusinessWebsite",
  },
  {
    path: "/product/:productId",
    exact: true,
    component: "Product",
  },
  {
    path: "/checkout",
    exact: true,
    component: "PaymentCheckout",
  },
  {
    path: "/campaign/:campaignId",
    exact: true,
    component: "MarketingCampaign",
    private: true,
  },
  {
    path: ["/", "/createbusinesssuccess"],
    exact: true,
    component: "CreateBusinessSuccess",
  },
    {
    path: ["/", "/explore"],
    exact: true,
    component: "Explore",
  },
  {
    path: ["/", "/onboarding"],
    exact: true,
    component: "Onboarding",
  },
  {
    path: "/payment-success",
    exact: true,
    component: "Payments/PaymentSuccess",
  },
  {
    path: "/payment-failure",
    exact: true,
    component: "Payments/PaymentFailure",
  },
  {
    path: "/payment-pending",
    exact: true,
    component: "Payments/PaymentPending",
  },
  {
    path: "/unsubscribe",
    exact: true,
    component: "Unsubscribe",
  },
  {
    path: "/privacy",
    exact: true,
    component: "Privacy",
  },
];

export default routes;